var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.vendor),callback:function ($$v) {_vm.vendor=$$v},expression:"vendor"}})}
var staticRenderFns = []

export { render, staticRenderFns }